import React, { Component } from 'react'
import Page from './Page'

class InfoPage extends Component {
  render () {
    return (
      <Page title='Information'>
        <article className='b-info'>
          <h2 className='b-info-title'>Steuer</h2>
          <h3 className='b-info-subtitle'>Big Subheadline</h3>
          <p>
            Non equidem invideo, miror magis posuere velit aliquet. A communi observantia non est recedendum. Nihil hic
            munitissimus habendi senatus locus, nihil horum? Qui ipsorum lingua Celtae, nostra Galli appellantur. Ambitioni
            dedisse scripsisse iudicaretur.
          </p>
          <p>
            Cum sociis natoque penatibus et magnis dis parturient. Nihilne te nocturnum praesidium Palati, nihil urbis
            vigiliae. Lorem ipsum dolor sit amet, consectetur adipisici elit, sed eiusmod tempor incidunt ut labore et dolore
            magna aliqua. Petierunt uti sibi concilium totius Galliae in diem certam indicere. Vivamus sagittis lacus vel
            augue laoreet rutrum faucibus.
          </p>
          <p>
            Salutantibus vitae elit libero, a pharetra augue. Cum ceteris in veneratione tui montes, nascetur mus. Quisque
            placerat facilisis egestas cillum dolore. Ab illo tempore, ab est sed immemorabili. Excepteur sint obcaecat
            cupiditat non proident culpa. Idque Caesaris facere voluntate liceret: sese habere.
            Nec dubitamus multa iter quae et nos invenerat. Unam incolunt Belgae, aliam Aquitani, tertiam. Prima luce, cum
            quibus mons aliud consensu ab eo. Curabitur blandit tempus ardua ridiculus sed magna.
            Tu quoque, Brute, fili mi, nihil timor populi, nihil! Hi omnes lingua, institutis, legibus inter se differunt.
            Quisque ut dolor gravida, placerat libero vel, euismod. Ullamco laboris nisi ut aliquid ex ea commodi consequat.
            Paullum deliquit, ponderibus modulisque suis ratio utitur. Etiam habebis sem dicantur magna mollis euismod.
          </p>
        </article>
      </Page>
    )
  }
}

export default InfoPage



// WEBPACK FOOTER //
// ./src/containers/page_steuer.js